export enum OrderStatusEnum {
    active = 'ACTIVE',
    destributed = 'DESTRIBUTED',
    ready = 'READY',
    onway = 'ONWAY',
    atwork = 'ATWORK',
    done = 'DONE',
    reject = 'REJECT',
}

export enum PersonStatusEnum {
    active = 'ACTIVE',
    inactive = 'INACTIVE',
}
